/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { CoderLaunchEligibilityResponse } from '../models/coder-launch-eligibility-response';
import { CoderWorkspaceResponse } from '../models/coder-workspace-response';
import { CreateWorkspaceExistingBranchRequest } from '../models/create-workspace-existing-branch-request';
import { CreateWorkspaceNewBranchRequest } from '../models/create-workspace-new-branch-request';

/**
 * Ui Coder Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiCoderControllerService extends __BaseService {
  static readonly identifyCoderLaunchEligibleUsingGETPath =
    '/cc-ui/v1/coder/stack/{stackName}/coder-eligibility';
  static readonly createWorkspaceWithExistingBranchUsingPOSTPath =
    '/cc-ui/v1/coder/stack/{stackName}/existing-branch';
  static readonly createWorkspaceWithNewBranchUsingPOSTPath =
    '/cc-ui/v1/coder/stack/{stackName}/new-branch';
  static readonly createWorkspaceWithExistingBranchUsingPOST1Path =
    '/cc-ui/v1/coder/stack/{stackName}/resourceType/{resourceType}/resourceName/{resourceName}/existing-branch';
  static readonly createWorkspaceWithNewBranchUsingPOST1Path =
    '/cc-ui/v1/coder/stack/{stackName}/resourceType/{resourceType}/resourceName/{resourceName}/new-branch';
  static readonly getAllUsingGET1Path =
    '/cc-ui/v1/coder/stack/{stackName}/resourceType/{resourceType}/resourceName/{resourceName}/workspaces';
  static readonly getAllUsingGET2Path =
    '/cc-ui/v1/coder/stack/{stackName}/workspaces';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * identifyCoderLaunchEligible
   * @param stackName stackName
   * @return OK
   */
  identifyCoderLaunchEligibleUsingGETResponse(
    stackName: string,
  ): __Observable<__StrictHttpResponse<CoderLaunchEligibilityResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/coder/stack/${encodeURIComponent(
          String(stackName),
        )}/coder-eligibility`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CoderLaunchEligibilityResponse>;
      }),
    );
  }
  /**
   * identifyCoderLaunchEligible
   * @param stackName stackName
   * @return OK
   */
  identifyCoderLaunchEligibleUsingGET(
    stackName: string,
  ): __Observable<CoderLaunchEligibilityResponse> {
    return this.identifyCoderLaunchEligibleUsingGETResponse(stackName).pipe(
      __map((_r) => _r.body as CoderLaunchEligibilityResponse),
    );
  }

  /**
   * createWorkspaceWithExistingBranch
   * @param params The `UiCoderControllerService.CreateWorkspaceWithExistingBranchUsingPOSTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `createWorkspaceExistingBranchRequest`: createWorkspaceExistingBranchRequest
   *
   * @return OK
   */
  createWorkspaceWithExistingBranchUsingPOSTResponse(
    params: UiCoderControllerService.CreateWorkspaceWithExistingBranchUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<CoderWorkspaceResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.createWorkspaceExistingBranchRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/coder/stack/${encodeURIComponent(
          String(params.stackName),
        )}/existing-branch`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CoderWorkspaceResponse>;
      }),
    );
  }
  /**
   * createWorkspaceWithExistingBranch
   * @param params The `UiCoderControllerService.CreateWorkspaceWithExistingBranchUsingPOSTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `createWorkspaceExistingBranchRequest`: createWorkspaceExistingBranchRequest
   *
   * @return OK
   */
  createWorkspaceWithExistingBranchUsingPOST(
    params: UiCoderControllerService.CreateWorkspaceWithExistingBranchUsingPOSTParams,
  ): __Observable<CoderWorkspaceResponse> {
    return this.createWorkspaceWithExistingBranchUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as CoderWorkspaceResponse),
    );
  }

  /**
   * createWorkspaceWithNewBranch
   * @param params The `UiCoderControllerService.CreateWorkspaceWithNewBranchUsingPOSTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `createWorkspaceNewBranchRequest`: createWorkspaceNewBranchRequest
   *
   * @return OK
   */
  createWorkspaceWithNewBranchUsingPOSTResponse(
    params: UiCoderControllerService.CreateWorkspaceWithNewBranchUsingPOSTParams,
  ): __Observable<__StrictHttpResponse<CoderWorkspaceResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.createWorkspaceNewBranchRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/coder/stack/${encodeURIComponent(
          String(params.stackName),
        )}/new-branch`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CoderWorkspaceResponse>;
      }),
    );
  }
  /**
   * createWorkspaceWithNewBranch
   * @param params The `UiCoderControllerService.CreateWorkspaceWithNewBranchUsingPOSTParams` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `createWorkspaceNewBranchRequest`: createWorkspaceNewBranchRequest
   *
   * @return OK
   */
  createWorkspaceWithNewBranchUsingPOST(
    params: UiCoderControllerService.CreateWorkspaceWithNewBranchUsingPOSTParams,
  ): __Observable<CoderWorkspaceResponse> {
    return this.createWorkspaceWithNewBranchUsingPOSTResponse(params).pipe(
      __map((_r) => _r.body as CoderWorkspaceResponse),
    );
  }

  /**
   * createWorkspaceWithExistingBranch
   * @param params The `UiCoderControllerService.CreateWorkspaceWithExistingBranchUsingPOST1Params` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `createWorkspaceExistingBranchRequest`: createWorkspaceExistingBranchRequest
   *
   * @return OK
   */
  createWorkspaceWithExistingBranchUsingPOST1Response(
    params: UiCoderControllerService.CreateWorkspaceWithExistingBranchUsingPOST1Params,
  ): __Observable<__StrictHttpResponse<CoderWorkspaceResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.createWorkspaceExistingBranchRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/coder/stack/${encodeURIComponent(
          String(params.stackName),
        )}/resourceType/${encodeURIComponent(
          String(params.resourceType),
        )}/resourceName/${encodeURIComponent(
          String(params.resourceName),
        )}/existing-branch`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CoderWorkspaceResponse>;
      }),
    );
  }
  /**
   * createWorkspaceWithExistingBranch
   * @param params The `UiCoderControllerService.CreateWorkspaceWithExistingBranchUsingPOST1Params` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `createWorkspaceExistingBranchRequest`: createWorkspaceExistingBranchRequest
   *
   * @return OK
   */
  createWorkspaceWithExistingBranchUsingPOST1(
    params: UiCoderControllerService.CreateWorkspaceWithExistingBranchUsingPOST1Params,
  ): __Observable<CoderWorkspaceResponse> {
    return this.createWorkspaceWithExistingBranchUsingPOST1Response(
      params,
    ).pipe(__map((_r) => _r.body as CoderWorkspaceResponse));
  }

  /**
   * createWorkspaceWithNewBranch
   * @param params The `UiCoderControllerService.CreateWorkspaceWithNewBranchUsingPOST1Params` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `createWorkspaceNewBranchRequest`: createWorkspaceNewBranchRequest
   *
   * @return OK
   */
  createWorkspaceWithNewBranchUsingPOST1Response(
    params: UiCoderControllerService.CreateWorkspaceWithNewBranchUsingPOST1Params,
  ): __Observable<__StrictHttpResponse<CoderWorkspaceResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.createWorkspaceNewBranchRequest;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl +
        `/cc-ui/v1/coder/stack/${encodeURIComponent(
          String(params.stackName),
        )}/resourceType/${encodeURIComponent(
          String(params.resourceType),
        )}/resourceName/${encodeURIComponent(
          String(params.resourceName),
        )}/new-branch`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CoderWorkspaceResponse>;
      }),
    );
  }
  /**
   * createWorkspaceWithNewBranch
   * @param params The `UiCoderControllerService.CreateWorkspaceWithNewBranchUsingPOST1Params` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * - `createWorkspaceNewBranchRequest`: createWorkspaceNewBranchRequest
   *
   * @return OK
   */
  createWorkspaceWithNewBranchUsingPOST1(
    params: UiCoderControllerService.CreateWorkspaceWithNewBranchUsingPOST1Params,
  ): __Observable<CoderWorkspaceResponse> {
    return this.createWorkspaceWithNewBranchUsingPOST1Response(params).pipe(
      __map((_r) => _r.body as CoderWorkspaceResponse),
    );
  }

  /**
   * getAll
   * @param params The `UiCoderControllerService.GetAllUsingGET1Params` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * @return OK
   */
  getAllUsingGET1Response(
    params: UiCoderControllerService.GetAllUsingGET1Params,
  ): __Observable<__StrictHttpResponse<Array<CoderWorkspaceResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/coder/stack/${encodeURIComponent(
          String(params.stackName),
        )}/resourceType/${encodeURIComponent(
          String(params.resourceType),
        )}/resourceName/${encodeURIComponent(
          String(params.resourceName),
        )}/workspaces`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<CoderWorkspaceResponse>>;
      }),
    );
  }
  /**
   * getAll
   * @param params The `UiCoderControllerService.GetAllUsingGET1Params` containing the following parameters:
   *
   * - `stackName`: stackName
   *
   * - `resourceType`: resourceType
   *
   * - `resourceName`: resourceName
   *
   * @return OK
   */
  getAllUsingGET1(
    params: UiCoderControllerService.GetAllUsingGET1Params,
  ): __Observable<Array<CoderWorkspaceResponse>> {
    return this.getAllUsingGET1Response(params).pipe(
      __map((_r) => _r.body as Array<CoderWorkspaceResponse>),
    );
  }

  /**
   * getAll
   * @param stackName stackName
   * @return OK
   */
  getAllUsingGET2Response(
    stackName: string,
  ): __Observable<__StrictHttpResponse<Array<CoderWorkspaceResponse>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/coder/stack/${encodeURIComponent(
          String(stackName),
        )}/workspaces`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<CoderWorkspaceResponse>>;
      }),
    );
  }
  /**
   * getAll
   * @param stackName stackName
   * @return OK
   */
  getAllUsingGET2(
    stackName: string,
  ): __Observable<Array<CoderWorkspaceResponse>> {
    return this.getAllUsingGET2Response(stackName).pipe(
      __map((_r) => _r.body as Array<CoderWorkspaceResponse>),
    );
  }
}

module UiCoderControllerService {
  /**
   * Parameters for createWorkspaceWithExistingBranchUsingPOST
   */
  export interface CreateWorkspaceWithExistingBranchUsingPOSTParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * createWorkspaceExistingBranchRequest
     */
    createWorkspaceExistingBranchRequest: CreateWorkspaceExistingBranchRequest;
  }

  /**
   * Parameters for createWorkspaceWithNewBranchUsingPOST
   */
  export interface CreateWorkspaceWithNewBranchUsingPOSTParams {
    /**
     * stackName
     */
    stackName: string;

    /**
     * createWorkspaceNewBranchRequest
     */
    createWorkspaceNewBranchRequest: CreateWorkspaceNewBranchRequest;
  }

  /**
   * Parameters for createWorkspaceWithExistingBranchUsingPOST1
   */
  export interface CreateWorkspaceWithExistingBranchUsingPOST1Params {
    /**
     * stackName
     */
    stackName: string;

    /**
     * resourceType
     */
    resourceType: string;

    /**
     * resourceName
     */
    resourceName: string;

    /**
     * createWorkspaceExistingBranchRequest
     */
    createWorkspaceExistingBranchRequest: CreateWorkspaceExistingBranchRequest;
  }

  /**
   * Parameters for createWorkspaceWithNewBranchUsingPOST1
   */
  export interface CreateWorkspaceWithNewBranchUsingPOST1Params {
    /**
     * stackName
     */
    stackName: string;

    /**
     * resourceType
     */
    resourceType: string;

    /**
     * resourceName
     */
    resourceName: string;

    /**
     * createWorkspaceNewBranchRequest
     */
    createWorkspaceNewBranchRequest: CreateWorkspaceNewBranchRequest;
  }

  /**
   * Parameters for getAllUsingGET1
   */
  export interface GetAllUsingGET1Params {
    /**
     * stackName
     */
    stackName: string;

    /**
     * resourceType
     */
    resourceType: string;

    /**
     * resourceName
     */
    resourceName: string;
  }
}

export { UiCoderControllerService };
